import { Link as ReactLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

const Link = ({ to, href, children, ...props }) => {
  if (href) return (<a href={href} {...props}>{children}</a>);
  return <ReactLink to={to} {...props}>{children}</ReactLink>;
};

Link.defaultProps = {
  children: null,
  href: '',
  to: ''
};

Link.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  to: PropTypes.string,
}

export default Link;